import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import profile from '../../../global/img/profile.png';
import twittericon from '../../../global/img/twitter.svg';
// This component mirrors NBATeam pattern by consuming Redux state
const TwitterFeed = () => {
  const { teamTwitterInfo = [], isLoading: loading, teamInfo } = useSelector((state) => state.teams);
  const error = null;
  const [visibleCount, setVisibleCount] = useState(3);
  const scrollRef = useRef(null);

  // Reset visible items when tweets change
  useEffect(() => {
    setVisibleCount(3);
    if (scrollRef.current) scrollRef.current.scrollTop = 0;
  }, [teamTwitterInfo]);

  const onScroll = (e) => {
    const target = e.currentTarget;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
      setVisibleCount((prev) => {
        const next = Math.min(prev + 3, teamTwitterInfo.length || 0);
        return next;
      });
    }
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const getTeamName = () => {
   
    // Prefer full team name from API teamInfo
    const fallbackTeamName = teamInfo?.[0]?.team_name || 'Team';
    if (!teamTwitterInfo || teamTwitterInfo.length === 0) return fallbackTeamName;
    const firstTweet = teamTwitterInfo[0];
    let nameFromProfile = '';
    try {
      const profileData = JSON.parse(firstTweet.profile_data || '{}');
      nameFromProfile = profileData?.name;
    } catch (e) {
      nameFromProfile = '';
    }
    return firstTweet.twitter_username || fallbackTeamName; //nameFromProfile || firstTweet.twitter_username || fallbackTeamName;
  };

  const getProfileImage = (tweet) => {
    console.log("tweet", tweet);
    if (!tweet) return profile;
    return tweet.profile_image_url || profile;
  };

  // No explicit error state from Redux here; component stays quiet like NBATeam

  return (
    <div className="news-column twitter-feed 789">
      <div className="news-header" style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, padding: '8px 0', borderBottom: '1px solid #eee' }}>
        <img src={twittericon} alt="X logo" />
        <h2 style={{ fontSize: '30px' }}>@{getTeamName()}</h2>
      </div>
      <div
        className="tweet-scroll"
        style={{
          width: '650px',
          height: teamTwitterInfo && teamTwitterInfo.length > 0 ? '600px' : '100px',
          overflowY: teamTwitterInfo && teamTwitterInfo.length > 0 ? 'auto' : 'hidden'
        }}
        onScroll={onScroll}
        ref={scrollRef}
      >
        {teamTwitterInfo && teamTwitterInfo.length > 0 ? (
          teamTwitterInfo.slice(0, visibleCount).map((tweet) => (
            <div key={tweet.tweet_id} className="news-post">
              <div className="post-profile">
                <img 
                  src={getProfileImage(tweet)} 
                  alt="profile" 
                  width="50px" 
                />
              </div>
              <div className="news-body">
                <div className="post-header">
                  <p>
                    <strong className="username">{tweet.twitter_username}</strong>
                    <span className="postdate">@{tweet.twitter_username} · {formatDate(tweet.tweet_date)}</span>
                  </p>
                </div>
                <div className="post-body">
                  {tweet.media_url && (
                    <img 
                      className="postimg" 
                      src={tweet.media_url} 
                      alt="Tweet media" 
                    />
                  )}
                  <p>{tweet.tweet_text}</p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#8a8a8a',
            fontStyle: 'italic'
          }}>
            No Twitter data available 4656
          </div>
        )}
      </div>     
    </div>
  );
};

export default TwitterFeed;